export default "__VITE_ASSET__DBCnZLZ3__"